'use strict';

var keyMirror = require('react/lib/keyMirror');

module.exports = keyMirror({
  STAMP_IN_TRENDING: null,
  STAMP_APPROVED_IN_ZINE: null,
  STAMP_REJECTED_FROM_ZINE: null,
  STAMP_SUBMITTED_TO_ZINE: null,
  STAMP_LIKED: null,
  STAMP_ADDED_TO_ZINE: null,
  ZINE_FOLLOWED: null,
  WELCOME_MESSAGE: null,
  USER_FOLLOWED: null,
  COLLECTED_IMAGE_PUBLISHED: null,
  DRAFT_FEEDBACK: null
});


/** WEBPACK FOOTER **
 ** ./constants/ActivityTypes.js
 **/